/** Primary sidebar nav label for `/<product>/design-system`. */
export const DESIGN_SYSTEM_PRIMARY_NAV_LABEL = "Design OS Catalog"

/** Drill-in home row when browsing the catalog registry. */
export const DESIGN_SYSTEM_DRILL_IN_HOME_LABEL = "Home"

/** Breadcrumbs, hero H1, and shell titles for the catalog hub. */
export const DESIGN_SYSTEM_HUB_LABEL = "Design OS Catalog"
